import { Component, Inject, LOCALE_ID, OnDestroy, OnInit } from '@angular/core';
import { Router, RouterEvent } from '@angular/router';
import { bellIcon, caretAltDownIcon, menuIcon, searchIcon, SVGIcon, userIcon  } from '@progress/kendo-svg-icons';
import { faSun, faMoon, faDesktop, IconDefinition } from '@fortawesome/free-solid-svg-icons';
import { AppBarThemeColor } from '@progress/kendo-angular-navigation';
import { UserViewModel, Permissions } from '../../shared/interfaces/viewmodels/userviewmodel';
import { AdminService } from '../../shared/services/admin.service';
import { ThemeSwitcherService, ThemeMode } from '../../core/theme-switcher/theme-switcher.service';
import { environment } from '../../../environments/environment'; 
import { Store } from '@ngxs/store';
import { Observable, Subscription } from 'rxjs';
import { AccountState } from '../../shared/store/state/account.state';
import { CldrIntlService, IntlService } from '@progress/kendo-angular-intl';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from '../../auth.service';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.css'],
    standalone: false
})
export class HeaderComponent implements OnInit, OnDestroy {
  public user$!: Observable<UserViewModel>;
  public hdbsOwnedWebsiteURL: string = 'http://hdbstech';
  public isAdescUser: boolean = false;
  public isWizdomUser: boolean = false;
  public isBhaUser: boolean = false;
  public isHartUser: boolean = false;
  public canViewEJDF: boolean = false;
  public canSubmitInternalRta: boolean = false;
  public canwizdomApproveBitRecord: boolean = false;
  public displayName: string = '';
  public currentHome: string = '';
  public curr: boolean = true;
  public sURL_2130CutterReclaimInventory: string = '';
  public sBHAwebsiteURL: string = '';
  public QuickSearch = "";
  public logoSelection: string = 'hartLogo.png'
  public themeModeDark: boolean = false;
  public menuIcon: SVGIcon = menuIcon;
  public bellIcon: SVGIcon = bellIcon;
  public searchIcon: SVGIcon = searchIcon;
  public userSvg: SVGIcon = userIcon;
  public dropDownIcon: SVGIcon = caretAltDownIcon;
  
  // Language flags mapping - using actual image paths
  public languageFlags: { [key: string]: string } = {
    'en-US': 'assets/images/Countries/64/United-kingdom-flag.png',
    'es-ES': 'assets/images/Countries/64/Spain-flag.png', 
    'de-DE': 'assets/images/Countries/64/Germany-flag.png',
    'fr-FR': 'assets/images/Countries/64/France-flag.png'
  };
  
  public showLanguageDropdown = false;
  
  public selectedLanguage = { locale: 'English', localeId: 'en-US' };
    public translations: Array<{ locale: string; localeId: string }> = [
      { locale: 'English', localeId: 'en-US' },
      { locale: 'Español', localeId: 'es-ES' },
      { locale: 'Deutsch', localeId: 'de-DE' },
      { locale: 'Français', localeId: 'fr-FR' },
    ];
  public show = false;
  public margin = { horizontal: -46, vertical: 7 };
  private themeSub?: Subscription;
  public isAuthenticated = false;
  public userDisplayName = '';
  public showProfileDropdown = false;
  public userEmail = '';

  asset_Location = environment.asset_location;

  // public UserSettings: UsersettingsService;
  constructor(private userSettings: AdminService,
    private router: Router,
    @Inject(LOCALE_ID) public localeId: string,
    public themeSwitcher: ThemeSwitcherService,
    public intlService: IntlService,
    public Translate: TranslateService,
    private store: Store,
    public authService: AuthService
  ) {
    this.localeId = this.selectedLanguage.localeId;
    this.setLocale(this.localeId);
    //this.UserSettings = userSettings;  
    this.userSettings.RetrievePermissionsCompleted.subscribe((r) => {
      let c = this.userSettings.UserPermissions;
      this.isAdescUser = this.userSettings.CheckPermission(Permissions.ADESC_USER);
      this.isWizdomUser = this.userSettings.CheckPermission(Permissions.WIZDOM_USER);
      this.isBhaUser = this.userSettings.CheckPermission(Permissions.BHA_ADMIN) || this.userSettings.CheckPermission(Permissions.BHA_READER);
      this.isHartUser = this.userSettings.CheckPermission(Permissions.HART_ADMIN) || this.userSettings.CheckPermission(Permissions.HART_USER);
      this.canViewEJDF = this.userSettings.CheckPermission(Permissions.VIEW_EJDF);
      this.canSubmitInternalRta = this.userSettings.CheckPermission(Permissions.SUBMIT_INTERNAL_RTA);
      this.canwizdomApproveBitRecord = this.userSettings.CheckPermission(Permissions.WIZDOM_APPROVE_BITRECORD)
    })
    this.displayName = this.userSettings.DisplayName
  }
  private setLocale(locale: string): void {
    (this.intlService as CldrIntlService).localeId = locale;
}
  get themeToggleLabel(): string {
    return this.themeSwitcher.theme === 'dark' ? 'Light Mode' : 'Dark Mode';
  }

  toggleTheme(): void {
    this.themeSwitcher.toggleTheme();
  }
  bind(theme: 'light' | 'dark' = this.themeSwitcher.currentTheme) {
    this.themeModeDark = theme === 'dark';
    this.logoSelection = theme === 'dark' ? 'hartLogo.png' : 'hartLogo_Light.png';
  }
  public onToggle(): void {
    this.show = !this.show;
  }
  getUserInitials(): string {
    if (!this.userDisplayName) return 'U';
    const names = this.userDisplayName.split(' ');
    if (names.length >= 2) {
      return (names[0][0] + names[names.length - 1][0]).toUpperCase();
    }
    return this.userDisplayName.substring(0, 2).toUpperCase();
  }
  
  toggleProfileDropdown(): void {
    this.showProfileDropdown = !this.showProfileDropdown;
    // Close language dropdown if open
    if (this.showProfileDropdown) {
      this.showLanguageDropdown = false;
    }
  }
  
  closeProfileDropdown(): void {
    this.showProfileDropdown = false;
  }
  
  navigateToSettings(): void {
    this.closeProfileDropdown();
    this.router.navigate(['/settings']);
  }
  
  public changeLanguage(item: { locale: string; localeId: string }): void {
    this.selectedLanguage = item;
    this.Translate.use(item.localeId);
  }
  
  toggleLanguageDropdown(): void {
    this.showLanguageDropdown = !this.showLanguageDropdown;
  }
  
  closeLanguageDropdown(): void {
    this.showLanguageDropdown = false;
  }
  
  // FontAwesome icons for theme toggle
  faSun = faSun;
  faMoon = faMoon;
  faDesktop = faDesktop;

  // Theme mode options
  public showThemeDropdown = false;
  public themeModes: { mode: ThemeMode; label: string; icon: IconDefinition }[] = [
    { mode: 'light', label: 'Light', icon: faSun },
    { mode: 'dark', label: 'Dark', icon: faMoon },
    { mode: 'system', label: 'System', icon: faDesktop },
  ];
  
  get currentThemeIcon(): IconDefinition {
    const mode = this.themeSwitcher.themeModeSetting;
    if (mode === 'system') return this.faDesktop;
    return mode === 'dark' ? this.faMoon : this.faSun;
  }
  
  get currentThemeTooltip(): string {
    const mode = this.themeSwitcher.themeModeSetting;
    if (mode === 'system') return 'Theme: System';
    return mode === 'dark' ? 'Theme: Dark' : 'Theme: Light';
  }

  toggleThemeDropdown(): void {
    this.showThemeDropdown = !this.showThemeDropdown;
  }

  closeThemeDropdown(): void {
    this.showThemeDropdown = false;
  }

  selectThemeMode(mode: ThemeMode): void {
    this.themeSwitcher.setMode(mode);
    this.showThemeDropdown = false;
  }
  ngOnInit() {
    this.user$ = this.store.select(AccountState.user);
    this.bind(this.themeSwitcher.currentTheme);
    this.themeSub = this.themeSwitcher.themeChanges.subscribe((theme) => this.bind(theme));
    this.checkAuthStatus();
    // this.userSettings.currentApplicationModule$.subscribe(r=>{
    //   if(r){
    //     this.currentHome=r
    //   }
    // });
    this.router.events.subscribe(event => {
      // debugger;
      if (event instanceof RouterEvent) {
        if (event.url && event.url.includes('ops')) {
          this.currentHome = 'ops'
          // this.usersettingsService._currentApplicationModule.next('ops');
          this.curr = true;
        }
        else if (event.url && event.url.includes('adesc')) {
          this.currentHome = 'adesc'
          // this.usersettingsService._currentApplicationModule.next('adesc');
          this.curr = false;
        }
        else if (event.url && event.url.includes('wizdom')) {
          this.currentHome = 'wizdom'
          // this.usersettingsService._currentApplicationModule.next('wizdom');
          this.curr = true;
        }
        else if (event.url && event.url.includes('hart')) {
          this.currentHome = 'hart'
          // this.usersettingsService._currentApplicationModule.next('wizdom');
          this.curr = true;
        }
        else if (event.url && event.url.includes('admin')) {
          this.currentHome = 'admin'
          // this.usersettingsService._currentApplicationModule.next('wizdom');
          this.curr = true;
        }
      }

    })
  }
  ngOnDestroy(): void {
    this.themeSub?.unsubscribe();
  }
  onKeyDown(event: KeyboardEvent) {
    if (event.key === 'Enter' || event.keyCode === 13) {
      event.preventDefault();
      if (this.isAdescUser) { window.open(`http://hdbstech/Adesc/Search?Quick=${this.QuickSearch}&s=1`, '_blank') }
      else if (this.isWizdomUser) { window.open(`http://hdbstech/wizdom/Search?Quick=${this.QuickSearch}&s=1`, '_blank') }
    }
  }

  checkAuthStatus() {
    try {
      // Wait a tick for MSAL to initialize
      setTimeout(() => {
        this.isAuthenticated = this.authService.isLoggedIn();
        if (this.isAuthenticated) {
          this.userDisplayName = this.authService.getUserDisplayName();
          this.userEmail = this.authService.getUserEmail() || '';
        }
      }, 0);
    }
    catch(ex){
      console.error("Error checking authentication status:", ex);
    }
  }

  login() {
    this.authService.loginRedirect();
  }

  logout() {
    this.closeProfileDropdown();
    this.authService.logoutRedirect();
  }

}
